import { useEffect, useRef, useState } from 'react';
import * as usersApi from '../api/users.api';

// 모듈 스코프 인메모리 캐시 — staleTime 30초
let cached: { data: usersApi.UserStats; at: number } | null = null;
let inflight: Promise<usersApi.UserStats> | null = null;
const STALE_MS = 30_000;

export interface UseMyStatsResult {
  stats: usersApi.UserStats | null;
  loading: boolean;
  error: Error | null;
  reload: () => void;
}

/** 모듈 스코프 캐시 초기화 (로그아웃/계정 전환 시 호출) */
export function resetStatsCache(): void {
  cached = null;
  inflight = null;
}

export function useMyStats(): UseMyStatsResult {
  const [stats, setStats] = useState<usersApi.UserStats | null>(cached?.data ?? null);
  const [loading, setLoading] = useState<boolean>(!cached);
  const [error, setError] = useState<Error | null>(null);
  const [tick, setTick] = useState(0);
  const mounted = useRef(true);
  useEffect(() => () => { mounted.current = false; }, []);

  useEffect(() => {
    const fresh = cached && Date.now() - cached.at < STALE_MS;
    if (fresh && tick === 0) { setStats(cached!.data); setLoading(false); return; }
    setLoading(true);
    const p = inflight ?? (inflight = usersApi.getMyStats().then((d) => { cached = { data: d, at: Date.now() }; return d; }).finally(() => { inflight = null; }));
    p.then((d) => { if (mounted.current) { setStats(d); setError(null); } })
     .catch((e: Error) => { if (mounted.current) setError(e); })
     .finally(() => { if (mounted.current) setLoading(false); });
  }, [tick]);

  return { stats, loading, error, reload: () => { cached = null; setTick((t) => t + 1); } };
}
